export enum EditOptionTypeEnum {
  TOGGLE = 'TOGGLE',
  DROPDOWN = 'DROPDOWN',
}
